module.exports = __webpack_public_path__ + "img/findings-animated.0d5656f7.gif";